/*
  Lista de desejos do tema (substitui o app Swishlist).

  Guarda handles de produto no localStorage do navegador — por aparelho, sem
  servidor. O tema ja traz os ganchos: o coracao dos cards
  (button.st-wishlist-button[data-handle], desenhado pelo CSS do tema, cheio
  com a classe st-is-added), o icone do cabecalho (a.wishlist-icon) e a
  pagina /pages/lista-de-desejos (secao ep-wishlist). Os cards da pagina sao
  renderizados pelo servidor via sections/ep-wishlist-cards.liquid, pedidos
  pela rota de busca (search.terms e o unico jeito de passar uma lista de
  handles ao Liquid).

  Configuracao em window.epWishlist (snippets/ep-wishlist-config.liquid).
*/
(function () {
  'use strict';
  var cfg = window.epWishlist || {};
  if (cfg.ativa === false) return;

  var CHAVE = 'ep_wishlist';
  var LOTE = 20; // all_products aceita 20 handles por renderizacao
  var SEL_BOTAO = '.st-wishlist-button[data-handle]';

  // ------------------------------------------------------------ dados ---
  function ler() {
    try {
      var v = JSON.parse(localStorage.getItem(CHAVE) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }
  function salvar(lista) {
    try {
      localStorage.setItem(CHAVE, JSON.stringify(lista));
    } catch (e) {
      /* modo privado sem espaco: a lista vive so nesta pagina */
    }
    atualizarBadge(lista.length);
  }
  function contem(handle) {
    return ler().indexOf(handle) >= 0;
  }
  function alternar(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i >= 0) lista.splice(i, 1);
    else lista.unshift(handle); // mais recente primeiro
    salvar(lista);
    return i < 0;
  }

  // -------------------------------------------------------------- toast ---
  function avisar(texto) {
    if (!texto) return;
    var alerta = document.querySelector('alert-component');
    if (!alerta) {
      alerta = document.createElement('alert-component');
      alerta.setAttribute('hidden', '');
      document.body.appendChild(alerta);
    }
    alerta.innerHTML = texto;
    alerta.removeAttribute('hidden');
    clearTimeout(alerta.__epTimer);
    alerta.__epTimer = setTimeout(function () {
      alerta.setAttribute('hidden', '');
    }, 3000);
  }

  // ------------------------------------------------------------- botoes ---
  /*
    Sem aria-pressed: o bundle do tema ainda carrega a ponte para o Swishlist
    (um MutationObserver por coracao que, vendo aria-pressed="true", faz
    classList.add — e classList.add gera registro de mutacao mesmo sem mudar
    nada, o que virava um loop infinito de microtarefas: pagina travada ao
    primeiro clique). O estado fica em data-ep-salvo; o rotulo acessivel
    muda com ele. So escreve o que mudou, para nao acordar observadores.
  */
  function marcar(botao, salvo) {
    if (botao.classList.contains('st-is-added') !== salvo) botao.classList.toggle('st-is-added', salvo);
    var estado = salvo ? 'true' : 'false';
    if (botao.getAttribute('data-ep-salvo') !== estado) botao.setAttribute('data-ep-salvo', estado);
    var rotulo = salvo ? cfg.textos.removerRotulo : cfg.textos.adicionarRotulo;
    if (rotulo && botao.getAttribute('aria-label') !== rotulo) botao.setAttribute('aria-label', rotulo);
    if (botao.getAttribute('type') !== 'button') botao.setAttribute('type', 'button');
  }
  function atualizarBotoes(raiz, apenasHandle) {
    var lista = ler();
    var botoes = (raiz || document).querySelectorAll(SEL_BOTAO);
    for (var i = 0; i < botoes.length; i++) {
      var h = botoes[i].getAttribute('data-handle');
      if (apenasHandle && h !== apenasHandle) continue;
      marcar(botoes[i], lista.indexOf(h) >= 0);
    }
  }

  document.addEventListener(
    'click',
    function (ev) {
      var botao = ev.target && ev.target.closest ? ev.target.closest(SEL_BOTAO) : null;
      if (!botao) return;
      ev.preventDefault();
      /* na captura, isto impede o clique de chegar ao botao — e ao listener
         que o tema ainda registra nele (ponte do Swishlist, que alternaria a
         classe de novo, desfazendo a nossa) */
      ev.stopPropagation();
      var handle = botao.getAttribute('data-handle');
      var salvo = alternar(handle);
      atualizarBotoes(document, handle);
      avisar(salvo ? cfg.textos.adicionado : cfg.textos.removido);
      if (!salvo) removerDaPagina(handle);
    },
    true
  );

  /* cards que entram depois (clones dos carrosseis, recomendacoes, gaveta) */
  new MutationObserver(function (mutacoes) {
    for (var i = 0; i < mutacoes.length; i++) {
      var add = mutacoes[i].addedNodes;
      for (var j = 0; j < add.length; j++) {
        var n = add[j];
        if (n.nodeType !== 1) continue;
        if (n.matches(SEL_BOTAO)) marcar(n, contem(n.getAttribute('data-handle')));
        else if (n.querySelector(SEL_BOTAO)) atualizarBotoes(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // -------------------------------------------------------------- badge ---
  function atualizarBadge(qtd) {
    if (qtd === undefined) qtd = ler().length;
    var icones = document.querySelectorAll('.wishlist-icon');
    for (var i = 0; i < icones.length; i++) {
      var icone = icones[i];
      var bolha = icone.querySelector('.ep-wishlist-bullet');
      if (!bolha) {
        bolha = document.createElement('span');
        bolha.className = 'ep-wishlist-bullet';
        bolha.innerHTML = '<span class="ep-wishlist-count"></span>';
        icone.appendChild(bolha);
      }
      bolha.querySelector('.ep-wishlist-count').textContent = qtd > 99 ? '99+' : String(qtd);
      bolha.hidden = qtd === 0;
    }
  }

  // ------------------------------------------------------------- pagina ---
  var pagina = null;
  function removerDaPagina(handle) {
    if (!pagina) return;
    var cards = pagina.grade.querySelectorAll('product-card[data-product-handle="' + handle + '"]');
    for (var i = 0; i < cards.length; i++) cards[i].remove();
    atualizarContagem();
  }
  function atualizarContagem() {
    if (!pagina) return;
    var n = pagina.grade.querySelectorAll('product-card').length;
    pagina.contagem.textContent = n === 1 ? cfg.textos.umProduto : String(n) + ' ' + cfg.textos.produtos;
    pagina.barra.hidden = n === 0;
    pagina.vazia.hidden = n !== 0;
    pagina.carregando.hidden = true;
  }

  function buscarCards(handles) {
    var url = (cfg.rotaBusca || '/search') + '?q=' + encodeURIComponent(handles.join(' ')) + '&section_id=ep-wishlist-cards';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var achados = {};
        var cards = doc.querySelectorAll('product-card[data-product-handle]');
        for (var i = 0; i < cards.length; i++) achados[cards[i].getAttribute('data-product-handle')] = cards[i];
        var ausentes = [];
        var faltas = doc.querySelectorAll('[data-ep-wishlist-ausente]');
        for (var k = 0; k < faltas.length; k++) ausentes.push(faltas[k].getAttribute('data-ep-wishlist-ausente'));
        return { achados: achados, ausentes: ausentes };
      });
  }

  // --------------------------------------------------- link curto (ids) ---
  /* base36: 9245981999337 -> "39zjmyhux" (9 caracteres em vez de ~42 do handle) */
  function codificarId(id) {
    return Number(id).toString(36);
  }
  function decodificarId(txt) {
    var n = parseInt(txt, 36);
    return isNaN(n) ? null : String(n);
  }
  var CACHE_CATALOGO = 'ep_wishlist_catalogo';
  /* id -> handle, via secao Liquid compacta (3,7 KB na rede); guardado na sessao */
  function catalogo() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_CATALOGO) || 'null');
      if (c && c.t && Date.now() - c.t < 3600000 && c.mapa) return Promise.resolve(c.mapa);
    } catch (e) {}
    var mapa = {};
    var pagina = function (n) {
      return fetch((cfg.rotaColecoes || '/collections') + '/all?section_id=ep-wishlist-catalogo&page=' + n, { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var raiz = doc.querySelector('[data-ep-wishlist-catalogo]');
          if (!raiz) throw new Error('catalogo sem conteudo');
          var linhas = raiz.textContent.split(String.fromCharCode(10));
          for (var i = 0; i < linhas.length; i++) {
            var p = linhas[i].indexOf(':');
            if (p > 0) mapa[linhas[i].slice(0, p).trim()] = linhas[i].slice(p + 1).trim();
          }
          var total = Number(raiz.getAttribute('data-paginas') || 1);
          return n < total ? pagina(n + 1) : mapa;
        });
    };
    return pagina(1).then(function (m) {
      try {
        sessionStorage.setItem(CACHE_CATALOGO, JSON.stringify({ t: Date.now(), mapa: m }));
      } catch (e) {}
      return m;
    });
  }

  function montarPagina(sec) {
    pagina = {
      sec: sec,
      grade: sec.querySelector('[data-ep-wishlist-grade]'),
      barra: sec.querySelector('[data-ep-wishlist-barra]'),
      contagem: sec.querySelector('[data-ep-wishlist-contagem]'),
      vazia: sec.querySelector('[data-ep-wishlist-vazia]'),
      carregando: sec.querySelector('[data-ep-wishlist-carregando]'),
      compartilhada: sec.querySelector('[data-ep-wishlist-compartilhada]'),
      compartilhar: sec.querySelector('[data-ep-wishlist-compartilhar]'),
      salvar: sec.querySelector('[data-ep-wishlist-salvar]')
    };
    if (!pagina.grade) return;

    var params = new URLSearchParams(location.search);
    var listaUrl = (params.get('lista') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var idsUrl = (params.get('ids') || '').split('.').map(function (x) { return decodificarId(x.trim()); }).filter(Boolean);
    var compartilhada = listaUrl.length > 0 || idsUrl.length > 0;
    var handles = compartilhada ? listaUrl : ler();

    if (compartilhada) {
      pagina.compartilhada.hidden = false;
      pagina.compartilhada.querySelector('[data-ep-wishlist-compartilhada-texto]').textContent = sec.getAttribute('data-msg-compartilhada') || '';
      if (pagina.salvar) {
        pagina.salvar.addEventListener('click', function () {
          var minha = ler();
          for (var i = listaUrl.length - 1; i >= 0; i--) if (minha.indexOf(listaUrl[i]) < 0) minha.unshift(listaUrl[i]);
          salvar(minha);
          atualizarBotoes(document);
          avisar(sec.getAttribute('data-msg-salva'));
          history.replaceState(null, '', location.pathname);
          pagina.compartilhada.hidden = true;
        });
      }
    }

    if (pagina.compartilhar) {
      pagina.compartilhar.addEventListener('click', function () {
        var atuais = [];
        var cards = pagina.grade.querySelectorAll('product-card[data-product-handle]');
        for (var i = 0; i < cards.length; i++) atuais.push(cards[i].getAttribute('data-product-handle'));
        var url;
        if (cfg.formatoLink === 'ids') {
          var ids = [];
          for (var k = 0; k < cards.length; k++) {
            var bb = cards[k].querySelector('[data-product-id]');
            if (bb) ids.push(codificarId(bb.getAttribute('data-product-id')));
          }
          url = location.origin + location.pathname + '?ids=' + ids.join('.');
        } else {
          url = location.origin + location.pathname + '?lista=' + encodeURIComponent(atuais.join(','));
        }
        var msg = sec.getAttribute('data-msg-link');
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { avisar(msg); }, function () { window.prompt(msg, url); });
        } else {
          window.prompt(msg, url);
        }
      });
    }

    /* link curto: resolve os ids para handles antes de montar */
    var pronto = Promise.resolve(handles);
    if (idsUrl.length) {
      pronto = catalogo().then(function (mapa) {
        var hs = [];
        for (var i = 0; i < idsUrl.length; i++) if (mapa[idsUrl[i]]) hs.push(mapa[idsUrl[i]]);
        listaUrl = hs;
        return hs;
      });
    }
    pronto.then(function (hs) { montarCards(hs, compartilhada); }).catch(function (e) {
      if (window.console) console.warn('[ep-wishlist]', e);
      pagina.carregando.hidden = true;
      avisar(sec.getAttribute('data-msg-erro'));
    });
  }

  function montarCards(handles, compartilhada) {
    var sec = pagina.sec;
    if (!handles.length) {
      atualizarContagem();
      return;
    }

    /* lotes de 20, em ordem; produto que sumiu da loja sai da lista */
    var lotes = [];
    for (var i = 0; i < handles.length; i += LOTE) lotes.push(handles.slice(i, i + LOTE));
    var ausentes = [];
    var cadeia = Promise.resolve();
    lotes.forEach(function (lote) {
      cadeia = cadeia.then(function () {
        return buscarCards(lote).then(function (r) {
          for (var i = 0; i < lote.length; i++) {
            var card = r.achados[lote[i]];
            if (card) pagina.grade.appendChild(card);
          }
          ausentes = ausentes.concat(r.ausentes);
          atualizarBotoes(pagina.grade);
          atualizarContagem();
        });
      });
    });
    cadeia.then(function () {
      if (!compartilhada && ausentes.length) {
        salvar(ler().filter(function (h) { return ausentes.indexOf(h) < 0; }));
      }
      atualizarContagem();
    }).catch(function (e) {
      if (window.console) console.warn('[ep-wishlist]', e);
      pagina.carregando.hidden = true;
      avisar(sec.getAttribute('data-msg-erro'));
    });
  }

  // ------------------------------------------------------------- inicio ---
  function iniciar() {
    atualizarBotoes(document);
    atualizarBadge();
    var sec = document.querySelector('[data-ep-wishlist]');
    if (sec && sec.getAttribute('data-ativa') === 'true') montarPagina(sec);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  /* outra aba mudou a lista */
  window.addEventListener('storage', function (ev) {
    if (ev.key === CHAVE) {
      atualizarBotoes(document);
      atualizarBadge();
    }
  });

  window.epWishlistApi = { ler: ler, alternar: alternar, contem: contem };
})();
